"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAPLES = void 0;
exports.STAPLES = {
    hour: 7,
    day: 12,
    month: 11,
};
